// @core/api/endpoints/userprofile/create_avatars_bulk.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateAvatarsBulkRequest,
  CreateAvatarsBulkResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Create multiple avatars
 * Creates multiple avatars in a single request for efficiency. Returns results indicating which avatars were created successfully and which failed.
 */
export async function CreateAvatarsBulk(
  data: CreateAvatarsBulkRequest,
  options?: RequestOptions
): Promise<CreateAvatarsBulkResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/avatars/bulk`;
  const requestOptions = options;
  return client.post<CreateAvatarsBulkResponse>(requestPath, data, requestOptions);
}
